import type { MotnMovie, MotnSeries } from '@setplex/tria-api'
import type { MotnItem } from '~/entities/motn'

import { decompressMotnItem } from '~/entities/motn'

export function isMotnMovie(item: MotnMovie | MotnSeries): item is MotnMovie {
  return item.contentType === 'MOTN_VOD'
}

export function isValidMotnItem(item: unknown): item is MotnItem {
  if (!item || typeof item !== 'object') return false
  const ct = (item as { contentType?: unknown }).contentType
  return ct === 'MOTN_VOD' || ct === 'MOTN_TV_SHOW'
}

export function parseMotnItemFromHash(
  hash: string | null | undefined
): MotnItem | null {
  const data = hash?.slice(1)
  if (!data) return null
  const item = decompressMotnItem(data)
  if (!item || !isValidMotnItem(item)) return null
  return item
}
